import { useGameStore } from '../state/store';

interface StartScreenProps {
  onStart: () => void;
}

export function StartScreen({ onStart }: StartScreenProps): JSX.Element {
  const gameMode = useGameStore((s) => s.gameMode);
  const setGameMode = useGameStore((s) => s.setGameMode);
  const coins = useGameStore((s) => s.coins);
  const stars = useGameStore((s) => s.stars);

  return (
    <div className="overlay start-overlay">
      <section className="start-card" aria-label="MOTORWELT Start">
        <img className="start-logo" src="/icons/motorwelt.svg" alt="" />
        <div className="start-copy">
          <p className="eyebrow">FAHREN · SAMMELN · BAUEN</p>
          <h1>MOTORWELT</h1>
          <div className="wallet" aria-label={`${coins} Münzen und ${stars} Sterne`}>
            <span>● {coins}</span><span>★ {stars}</span>
          </div>
        </div>
        <div className="start-actions">
          <button type="button" className="btn play-btn" onClick={onStart}>
            <span className="icon" aria-hidden="true">▶</span> START
          </button>
          <div className="start-control" aria-label="Spielmodus wählen">
            <button
              type="button"
              className={`choice compact${gameMode === 'free' ? ' selected' : ''}`}
              onClick={() => setGameMode('free')}
            >
              🛣️ <span>FREIE FAHRT</span>
            </button>
            <button
              type="button"
              className={`choice compact${gameMode === 'parking' ? ' selected' : ''}`}
              onClick={() => setGameMode('parking')}
            >
              🅿️ <span>PARKEN</span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
